/* React hooks */
import {createContext, useState} from "react";


const PagerContext = createContext({ });

export const PagerProvider = ({ children }) => {
    const [ currentPage, setCurrentPage ] = useState(1);
    const [ itemsPerPage, setItemsPerPage ] = useState(10);
    const [ totalPages, setTotalPages ] = useState(1);
    const [ lastItemIndex, setLastItemIndex ] = useState(0);
    const [ firstItemIndex, setFirstItemIndex ] = useState(0);

    return (
        <PagerContext.Provider value={{
            currentPage, setCurrentPage,
            itemsPerPage, setItemsPerPage,
            totalPages, setTotalPages,
            lastItemIndex, setLastItemIndex,
            firstItemIndex, setFirstItemIndex
        }}>
            { children }
        </PagerContext.Provider>
    )
}

export default PagerContext;